import { marketingService, eventService } from '../../services/homii-services';

async function getMarketingCampaignDataByName(campaignName) {
    const response = await marketingService.getMarketingCampaignDataByName(campaignName);
    return response;
};
  
async function submitWebsiteVisited(referrer) {
    await marketingService.submitWebsiteVisited(referrer);
    eventService.logCustomEvent('website_visited_referrer', {
        description: `User successfully visited website with referrer code: ${referrer}`,
        referrer,
    });
};

export default {
    getMarketingCampaignDataByName,
    submitWebsiteVisited
};